import { render, staticRenderFns } from "./mutipleAuthSubShopList.vue?vue&type=template&id=956ecba0&scoped=true"
import script from "./mutipleAuthSubShopList.vue?vue&type=script&lang=ts"
export * from "./mutipleAuthSubShopList.vue?vue&type=script&lang=ts"
import style0 from "./mutipleAuthSubShopList.vue?vue&type=style&index=0&id=956ecba0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956ecba0",
  null
  
)

export default component.exports